module.exports = __webpack_public_path__ + "static/media/password.6a7d70d8.svg";